<template>
  <div class="date_select">
    <DatePicker
      v-model="date"
      color="gray"
      :is24hr="true"
      :min-date="new Date()"
      :minute-increment="5"
      is-required
      @popover-did-hide="checkDate"
      @input="dateSelected"
    >
      <template #default="{ inputValue, togglePopover }">
        <div
          class="calendar-contain"
          @click="togglePopover()"
        >
          <img
            class="img-calendar"
            src="@/assets/icons/myday/calendar.svg"
            alt="calendar"
          >
          <input
            :value="inputValue"
            readonly
            :class="{ red: wrongDate }"
          >
        </div>
      </template>
    </DatePicker>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'

export default {
  name: 'FormCalendar',
  components: {
    DatePicker
  },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    name: String
  },
  emits: ['dataSelected', 'addData'],
  data() {
    return {
      date: this.getActualDateWithMin(),
      wrongDate: false
    }
  },
  mounted() {
    EventBus.emit('dateSelected', this.date)
  },
  methods: {
    dateSelected() {
      EventBus.emit('dateSelected', this.date)
    },
    selectDate() {
      this.$emit('dataSelected', this.date)
      this.$emit('addData', { value: this.date, name: this.name })
    },
    getActualDateWithMin() {
      let actualDate = new Date()
      actualDate.setMinutes(actualDate.getMinutes() + 5)
      return actualDate
    },
    checkDate() {
      if (new Date(this.date).getTime() < new Date().getTime()) {
        this.wrongDate = true
        setTimeout(() => {
          this.date = this.getActualDateWithMin()
          this.wrongDate = false
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .date_select {
    display: flex;
    color: grey;
    border: 1px solid rgb(177 177 177 / 82.2%);
    border-radius: 3px;
    margin-bottom: 5px;
  }

  .calendar-contain {
    display: flex;

    > input {
      font-size: 0.8rem !important;
    }
  }

  .img-calendar {
    height: 27px;
    margin: 5px 8px 0 4px;
  }

  .red {
    color: red;
    font-weight: bold;
  }
</style>
